import React from "react";
import { Box, Typography, Button } from "@mui/material";

import StatusChip from "../Common/StatusChip";
import ProgressBar from "../Common/ProgressBar";

export default function TutorialCard({
    title,
    unlocks, // null until backend adds an unlock-machine field — line hides itself
    progress,
    status,
    buttonText,
    onAction,
}) {
    return (
        <Box
            sx={{
                border: "1px solid #E8EDF5",
                backgroundColor:"#F1F4F9",
                borderRadius: "14px",
                p: 2,
                mb: 2,
                "&:last-child": {
                    mb: 0,
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 1.5,
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
                    {title}
                </Typography>

                <StatusChip status={status} />
            </Box>

            {unlocks && (
                <Typography
                    sx={{
                        color: "#64748B",
                        fontSize: 14,
                        mb: 2,
                    }}
                >
                    Unlocks: {unlocks}
                </Typography>
            )}

            <ProgressBar value={progress} />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                }}
            >
               <Button
                      variant="outlined"
                      
                      sx={{
                          minWidth: 120,
                          height: 34,
                          borderRadius: "8px",
                          borderColor: "#8B7BFF",
                          color: "#6D5DF6",
                          backgroundColor: "#fff",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 13,
              
                          "&:hover": {
                              borderColor: "#6D5DF6",
                              backgroundColor: "#F6F4FF",
                          },
                      }}
                  >
                      {buttonText}
                  </Button>
            </Box>
        </Box>
    );
}
